export default [

  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/main/Dashboard.vue'),
    // component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/change-profile',
    name: 'reloadPage',
    // component: () => import('@/views/dashboard/main/Dashboard.vue'),
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    meta: {
      authRequired: true
    }
  },
]
